import { useMemo, useState } from "react";
import { ChevronDown } from "lucide-react";

export default function CurrencySelector({ selectedCurrency = [] }) {
  const [selectedCurrencyId, setSelectedCurrencyId] = useState(
    selectedCurrency?.[0]?.currency_id || ""
  );

  const currentCurrency = useMemo(() => {
    return (
      selectedCurrency.find(
        (item) => item.currency_id === Number(selectedCurrencyId)
      ) || selectedCurrency[0]
    );
  }, [selectedCurrency, selectedCurrencyId]);

  if (!selectedCurrency.length) return null;

  return (
    <div className="space-y-4 mt-2">
        <div className="flex gap-2">
      <div className="w-20 ">
<div className="relative w-full">
  <select
    value={selectedCurrencyId}
    onChange={(e) => setSelectedCurrencyId(e.target.value)}
    className="w-full appearance-none border rounded-lg px-3 pr-8 py-2 outline-none focus:ring-2 focus:ring-red-500 cursor-pointer"
  >
    {selectedCurrency.map((currency) => (
      <option
        key={currency.currency_id}
        value={currency.currency_id}
      >
        {currency.currency_code}
      </option>
    ))}
  </select>

  <ChevronDown
    size={18}
    className="pointer-events-none absolute right-2 top-1/2 -translate-y-1/2 text-gray-500"
  />
</div>
      </div>

      {/* Price */}
      {currentCurrency && (
        <div className="space-y-1">
          {currentCurrency.sale_price ? (
            <>
              <div className="flex items-center gap-3">
                <span className="text-3xl font-bold text-red-600">
                  {currentCurrency.symbol}
                  {currentCurrency.sale_price}
                </span>

                <span className="text-lg text-gray-400 line-through">
                  {currentCurrency.symbol}
                  {currentCurrency.price}
                </span>
                <p className="text-sm text-green-600">
                {Math.round(
                  ((currentCurrency.price - currentCurrency.sale_price) /
                    currentCurrency.price) *
                    100
                )}
                % OFF
              </p>
              </div>
            </>
          ) : (
            <span className="text-3xl font-bold text-red-600">
              {currentCurrency.symbol}
              {currentCurrency.price}
            </span>
          )}
        </div>
      )}
      </div>
    </div>
  );
}